import React from 'react';
export const Toggle2On = props => (
  <svg viewBox="0 0 20 20" width="16px" height="16px" {...props} className={`btfont ${props.className ? props.className : ''}`}><path d="M7 5H3a3 3 0 0 0 0 6h4a4.995 4.995 0 0 1-.584-1H3a2 2 0 1 1 0-4h3.416c.156-.357.352-.692.584-1z" fillRule="evenodd" />,
<path d="M16 8A5 5 0 1 1 6 8a5 5 0 0 1 10 0z" fillRule="evenodd" /></svg>
);
